import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  buttonContainer: {
    paddingTop: indent * 2,
    paddingBottom: indent * 4,
    display: 'flex',
  },
  button: {
    paddingHorizontal: indent * 0.8,
    paddingVertical: indent * 0.4,
    borderRadius: 8,
  },
  loadingContainer: {
    width: '100%',
  },
  loading: {
    width: '100%',
    paddingHorizontal: indent * 0.75,
  },
});
